import vue from 'vue'
import vuex from 'vuex'
vue.use(vuex)
const store = new vuex.Store({
	state: {
		//	userList: [],
		includedComponents: ",",
		excludedComponents: ""
	},
	mutations: {
		//	setUserList(state, data) {
		//		state.userList = data;
		//	},
		show(state, data) {
			state.includedComponents = data
		}
	},
	action: {
		//	commitUserList: ({
		//		commit
		//	}, userList) => commit('setUserList', userList)
	}
})
export default store